import _ from 'lodash';
import { fork, put, select, takeLatest } from 'redux-saga/effects';
import { FLEXI_12_URL } from '../myAccount/dashboard/Dashboard.sagas';
import {
    MULTI_LOAN_DASHBOARD_DISABLE_REDIRECT,
    MULTI_LOAN_DASHBOARD_ENABLE_REDIRECT
} from '../myAccount/multiLoanDashboard/Dashboard.actions';
import {
    getCurrentLocation,
    getHistory,
    isNotCurrentRelativeURL,
    navigateTo,
    updateURLTo
} from './HistoryProvider';
import {
    BOOTSTRAP_ROUTER,
    CHANGE_ROUTER,
    CONFIRM_REROUTING,
    REQUEST_CHANGE_ROUTER,
    UPDATE_URL
} from './IwRouter.actions';
import { addQueryParameterInLocation, buildEvent } from './LocationHelper';

export const routerSagaWorkers = [
    fork(requestChangeRouterWorker),
    fork(bootstrapRouterWorker),
    fork(updateURLRouterWorker)
];

function* bootstrapRouterWorker() {
    yield takeLatest([BOOTSTRAP_ROUTER, 'TEST_BOOTSTRAP'], function* () {
        const event = buildEvent(getHistory());
        yield put({ type: CHANGE_ROUTER, ...event });
    });
}

function* requestChangeRouterWorker() {
    yield takeLatest(REQUEST_CHANGE_ROUTER, function* (action) {
        const routerBlocked = yield select(
            (state) => state.history.routerBlocked
        );

        const { impersonating, impersonatingStateKey } = yield select(
            ({ siteContext }) => siteContext
        );

        if (impersonating) {
            action.location = addQueryParameterInLocation(
                action.location,
                'state_key',
                impersonatingStateKey
            );
        }

        if (action.location.pathname === FLEXI_12_URL) {
            if (action.disableRedirect) {
                yield put({ type: MULTI_LOAN_DASHBOARD_DISABLE_REDIRECT });
            } else {
                yield put({ type: MULTI_LOAN_DASHBOARD_ENABLE_REDIRECT });
            }
        }

        if (routerBlocked) {
            yield put({
                type: CONFIRM_REROUTING,
                location: getCurrentLocation()
            });
        } else {
            //TODO: this should be yielded
            navigateTo(action.location);
        }
    });
}

function* updateURLRouterWorker() {
    yield takeLatest(UPDATE_URL, function* (action) {
        if (isNotCurrentRelativeURL(action.pathname, action.search)) {
            let updatedLocation = {
                pathname: action.pathname,
                search: ''
            };

            if (_.isString(action.search)) {
                updatedLocation.search = action.search;
            }

            const { impersonating, impersonatingStateKey } = yield select(
                ({ siteContext }) => siteContext
            );

            if (impersonating) {
                updatedLocation = addQueryParameterInLocation(
                    updatedLocation,
                    'state_key',
                    impersonatingStateKey
                );
            }

            yield updateURLTo(updatedLocation, action.options);
        }
    });
}
